import apiService from "../../api/api.service";
import {
  ToggleFavoriteResponse,
  FavoritesResponse,
  FavoriteIdsResponse,
  FavoriteTabsResponse,
  GetFavoritesRequest,
  BulkDeleteFavoritesRequest,
  BulkDeleteFavoritesResponse,
} from "./favorite.types";

/**
 * Toggle product favorite status
 */
export const toggleFavorite = (productId: number, variantId?: number) => {
  return apiService.post<ToggleFavoriteResponse>(
    `/products/${productId}/toggle-favorite`,
    undefined,
    variantId ? { params: { product_variant_id: variantId } } : undefined,
  );
};

/**
 * Get favorite products with pagination and filters
 */
export const getFavorites = (params?: GetFavoritesRequest) => {
  return apiService.get<FavoritesResponse>("/customers/favorites", { params });
};

/**
 * Get only favorite product IDs
 */
export const getFavoriteIds = () => {
  return apiService.get<FavoriteIdsResponse>("/customers/favorites/ids");
};

/**
 * Get favorite tabs
 */
export const getFavoriteTabs = () => {
  return apiService.get<FavoriteTabsResponse>("/customers/favorites/tabs");
};

/**
 * Bulk delete favorites
 */
export const bulkDeleteFavorites = (data: BulkDeleteFavoritesRequest) => {
  return apiService.delete<BulkDeleteFavoritesResponse>(
    "/customers/favorites/bulk-delete",
    data,
  );
};
